import { FleekError } from './FleekError';

type FleekFunctionSlugNotValidErrorOptions = {
  slug: string;
};

export class FleekFunctionSlugNotValidError extends FleekError<FleekFunctionSlugNotValidErrorOptions> {
  public name = 'FleekFunctionSlugNotValidError';

  toString = () => {
    return `The slug, ${this.data.slug}, is invalid`;
  };
}
